import {
  Button,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
  Spinner,
} from "reactstrap";
import { reverseFormatKey } from "../../utils/formatKey";

export const microgridData = [
  { group: "カーポート 1", items: ["PV-PCS01", "PV-PCS02", "PV-PCS03"] },
  {
    group: "カーポート 2",
    items: [
      "PV-PCS04",
      "PV-PCS05",
      "PV-PCS06",
      "PV-PCS07",
      "PV-PCS08",
      "PV-PCS09",
      "PV-PCS10",
    ],
  },
  {
    group: "蓄電池",
    items: ["BT-PCS01", "BT-PCS02", "BT-PCS03", "BT-PCS04"],
  },
];

export const townHallData = [
  { group: "屋上", items: ["PV-PCS01", "PV-PCS02"] },
  { group: "カーポート", items: ["PV-PCS03", "PV-PCS04", "PV-PCS05"] },
  { group: "蓄電池", items: ["BT-PCS01"] },
];

export const mapEventInfoToGroups = (groups, eventGroup) => {
  return groups.map((group) => {
    const states = group.items.map((item) => {
      const key = reverseFormatKey(item);

      return eventGroup?.[key] !== undefined ? eventGroup[key] : true;
    });

    return {
      ...group,
      states,
      all: states.every(Boolean),
    };
  });
};

export const microAllocations = [
  [1, 2],
  [3, 4],
  [2, 2],
];

export const townAllocations = [
  [1, 1],
  [1, 2],
  [0, 1],
];

export const microCustomAllocations = {
  1: { col7: [0, 2, 4], col5: [1, 3, 5, 6] },
  2: { col7: [0, 2], col5: [1, 3] },
};

const toggleAll = (groups, setGroups, groupIndex) => {
  setGroups((prev) => {
    const newGroups = [...prev];
    const newValue = !newGroups[groupIndex].all;
    newGroups[groupIndex].all = newValue;
    newGroups[groupIndex].states = newGroups[groupIndex].states.map(
      () => newValue,
    );
    return newGroups;
  });
};

const toggleItem = (groups, setGroups, groupIndex, itemIndex) => {
  setGroups((prev) => {
    const newGroups = [...prev];
    newGroups[groupIndex].states[itemIndex] =
      !newGroups[groupIndex].states[itemIndex];
    newGroups[groupIndex].all = newGroups[groupIndex].states.every(Boolean);
    return newGroups;
  });
};
export const renderGroups = (
  groups,
  setGroups,
  allocations,
  customAllocations = {},
  readOnly = false,
) =>
  groups.map((group, gIdx) => {
    const custom = customAllocations[gIdx];

    let col7Items = [];
    let col5Items = [];

    if (custom) {
      col7Items = custom.col7.map((i) => ({ item: group.items[i], iIdx: i }));
      col5Items = custom.col5.map((i) => ({ item: group.items[i], iIdx: i }));
    } else {
      const totalItems = group.items.length;
      const [lRaw, rRaw] = allocations[gIdx] || [0, totalItems];
      const leftCount = Math.min(lRaw, totalItems);
      const rightCount = Math.min(rRaw, totalItems - leftCount);

      col7Items = group.items
        .slice(0, leftCount)
        .map((item, i) => ({ item, iIdx: i }));
      col5Items = group.items
        .slice(leftCount, leftCount + rightCount)
        .map((item, i) => ({ item, iIdx: leftCount + i }));
    }

    const isBalanced = col7Items.length === col5Items.length;

    const renderItem = (item, iIdx) => (
      <Col
        key={iIdx}
        className="equipment-item d-flex align-items-center gap-3"
      >
        <span>{item}</span>
        <div className="d-flex align-items-center gap-2">
          <span>待機</span>
          <FormGroup switch>
            <Input
              type="switch"
              checked={group.states[iIdx]}
              onChange={() =>
                !readOnly && toggleItem(groups, setGroups, gIdx, iIdx)
              }
            />
            <Label check>稼働</Label>
          </FormGroup>
        </div>
      </Col>
    );

    return (
      <Row key={gIdx} className="bodyRow">
        <Col xs={7} className="px-0">
          <div className="buttonDiv">
            <span className="carport">{group.group}</span>
            <div className="d-flex align-items-center">
              <span className="carport">全て</span>
              <FormGroup switch>
                <Input
                  type="switch"
                  checked={group.all}
                  onChange={() =>
                    !readOnly && toggleAll(groups, setGroups, gIdx)
                  }
                />
              </FormGroup>
            </div>
          </div>

          <div
            className={`d-flex flex-column align-items-end  ${
              isBalanced ? "col7EqualBox" : "col7Box"
            }`}
          >
            {col7Items.map(({ item, iIdx }) => renderItem(item, iIdx))}
          </div>
        </Col>

        <Col xs={5} className={`mt-2 ${isBalanced ? "balanced-offset" : ""} `}>
          {col5Items.map(({ item, iIdx }) => renderItem(item, iIdx))}
        </Col>
      </Row>
    );
  });
